export const isStringMatchingDatePattern = (string: string) => {
  // Check if string looks like a date format (YYYY-MM-DD style with SQL or ISO datetime)
  return /^\d{4}-\d{2}-\d{2}([ T]\d{2}:\d{2}:\d{2})?/.test(string);
};
